import React, { useEffect, useState } from "react";
import { FaUsers, FaPhoneAlt } from "react-icons/fa"; // Icons for admissions and contacts
import SummaryApi from "../common";
const Dashboard = () => {
 
  return (
    <div>
      <h2 className="text-3xl font-bold text-center mb-8">Dashboard</h2>
    
      
    </div>
  );
};
export default Dashboard;